<template lang="pug">

	.sitemap
		.container
			Breadcrumbs(:breadcrumbsList="breadcrumbsList")

			h1.page-title {{ $t('pages.sitemap.heading') }}

			ul.sitemap__list
				li.sitemap__list-item(v-for="(item, index) in menu" :key="index")
					nuxt-link.sitemap__basic-text(:to="localePath({ name: item.slug, params: { slug: item.slug } }) + '/'") {{ item.title }}

					ul.sitemap__submenu(v-if="item.submenu")
						li.sitemap__submenu-item(v-for="(subItem, index) in item.submenu" :key="index")
							nuxt-link.sitemap__submenu-text(:to="localePath({ name: 'product-category-slug', params: { slug: subItem.slug } })  + '/'") {{ subItem.title }}

</template>

<script>
import Breadcrumbs from '@/components/partials/Breadcrumbs'

export default {
	layout: 'no-sidebar',

	components: { 
		Breadcrumbs,
	},

	data() {
    return {
      breadcrumbsList: [
        {
          link: this.localePath('index'),
          name: this.$t('breadcrumbs.home')
				},
				{
					link: this.localePath('sitemap'),
          name: this.$t('breadcrumbs.sitemap')
				}
			],
			menu: [
        {
          title: this.$t('mainMenu.item1'),
          slug: 'catalog',
          submenu: [
            {
              title: this.$t('mainMenu.submenu.item1'),
              slug: 'pumps'
            },
            {
              title: this.$t('mainMenu.submenu.item2'),
              slug: 'sandals'
            },
            {
              title: this.$t('mainMenu.submenu.item3'),
              slug: 'sneakers'
            }
          ]
        },
        {
          title: this.$t('mainMenu.item2'),
          slug: 'about-us'
        },
        {
          title: this.$t('mainMenu.item3'),
          slug: 'boutiques'
        },
        {
          title: this.$t('mainMenu.item4'),
          slug: 'contacts'
        }
      ]
    }
  },

}
</script>

<style lang="scss" scoped>

.sitemap {
	padding: 20px 0px 30px;

	.page-title {
		font-size: 32px;
		line-height: 36px;
		padding-bottom: 10px;
		border-bottom: 1px solid #E5E5E5;
		margin: 10px 0px 25px;
	}
	&__list {
		&-item {
			margin-bottom: 15px;
			&:last-of-type {
				margin-bottom: 0px;
			}
		}
	}
	&__basic-text {
		font-size: 18px;
		line-height: 27px;
		text-transform: uppercase;
	}
	&__submenu {
		margin: 8px 0px;
		&-item {
			margin-bottom: 8px;
		}
		&-text {
			font-size: 18px;
			line-height: 27px;
			color: rgba(29, 19, 0, 0.6);
			text-transform: capitalize;
		}
	}
}
</style>
